function repeat(element: string, length: number) {
	let result = "";
	for (let i = 0; i < length; i++) {
		result += element;
	}
	return result;
}

function trimEnd(source: string, char: string) {
	let result = source;
	while (result.endsWith(char)) {
		result = result.substring(0, result.length - char.length);
	}
	return result;
}

function trimStart(source: string, char: string) {
	let result = source;
	while (result.startsWith(char)) {
		result = result.substring(char.length);
	}
	return result;
}

function capitalize(source: string) {
	return source.charAt(0).toUpperCase() + source.substring(1).toLowerCase();
}

export { capitalize, repeat, trimStart, trimEnd };
